




























































































































import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Navigation extends Vue {
  drawer = false;

  bg = 'transparent';

  isScrolled = false;

  protected created() {
    window.addEventListener('scroll', this.changeColor);
  }

  private changeColor() {
    if (
      document.body.scrollTop > 100 ||
      document.documentElement.scrollTop > 100
    ) {
      this.bg = 'white';
      this.isScrolled = true;
    } else {
      this.bg = 'transparent';
      this.isScrolled = false;
    }
  }
}
